export default {"src":"/_next/static/media/vtuber-title.b22a6cbc.svg","height":17,"width":72};